<template>
    <div id="trusts" class="home-trusts">
        <div class="trusts-container">
            <h2 class="home-trusts__title">300.000 Belgen vertrouwen al op ons, <br> dus waar wacht je op!</h2>
            <ul class="trust-list">
                <li class="trust">
                    <img src="/images/nl_multigift/trust1.svg">
                    <div>
                        <strong class="trust-title">60 jaar</strong><br>
                        <span class="trust-subtitle">expertise</span>
                    </div>
                </li>
                <li class="trust">
                    <img src="/images/nl_multigift/trust2.svg">
                    <div>
                        <strong class="trust-title">De grootste</strong><br>
                        <span class="trust-subtitle">consumentenorganisatie in <br>België</span>
                    </div>
                </li>
                <li class="trust">
                    <img src="/images/nl_multigift/trust3.svg">
                    <div>
                        <strong class="trust-title">Onafhankelijk</strong><br>
                        <span class="trust-subtitle">van lobby’s of <br> merken</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name: "HomeTrust",
}
</script>

<style scoped>

</style>
